module.exports = __webpack_public_path__ + "img/smart-construction-section-3-phone2.9fd2d36b.png";